<template>
    <el-container style="width:100%;">
        <el-header>
            <el-form :inline="true" :model="fromResource" ref="fromResource" class="demo-form-inline">
                <td-permission :oneOfPermissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.ID')" prop="sSrcId">
                            <td-input v-model="fromResource.sSrcId"></td-input>
                        </el-form-item>
                        <el-form-item :label="$t('common.RESTYPENAME')" prop="sResourceName">
                            <td-input v-model="fromResource.sResourceName"></td-input>
                        </el-form-item>
                        <el-form-item :label="$t('common.BELONG_TO_QUEUE')" prop="sQueueName">
                            <td-input v-model="fromResource.sQueueName"></td-input>
                        </el-form-item>
                        <el-form-item class="paddingLeft10">
                            <td-button type="primary" :loading="loading" :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" @click="btnQuery">{{
                                $t('common.QUERY')
                            }}</td-button>
                        </el-form-item>
                    </div>
                </td-permission>
                <el-form-item>
                    <td-button type="button" :permissions="permissionsAdd" @click="btnAddResource">{{ $t('common.ADD') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :permissions="permissionsQuery"
                :hasLoading="tableLoading"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :hasMutiSelect="false"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-ResourceInfo
                v-if="dialogResourceVisible"
                :isAddData="isAddData"
                :dialogResourceVisible="dialogResourceVisible"
                :editItem="editItem"
                :title="title"
                ref="addOrModifyInfo"
                @resourceDialogClose="resourceDialogClose"
                @queryDataList="queryDataList"
            ></dialog-ResourceInfo>
        </el-main>
    </el-container>
</template>

<script>
import resourceApi from './assets/api.js';
import dialogResourceInfo from './components/dialogResourceInfo.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-ResourceInfo': dialogResourceInfo
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        // this.queryDataList(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            permissionsQuery: ['resource:view'],
            permissionsAdd: ['resource:add'],
            fromResource: {
                sQueueName: '',
                sResourceName: '',
                sSrcId: ''
            },
            editItem: '',
            listMqInfo: [],
            dialogResourceVisible: false,
            dialogRelatedSetVisible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false,
            tableLoading: false,
            columns: [
                {
                    prop: 'sSrcId',
                    label: 'common.ID',
                    tableWidth: '200',
                    showOverflowTooltip: true
                },
                {
                    prop: 'sName',
                    label: 'common.RESTYPENAME',
                    tableWidth: '200',
                    showOverflowTooltip: true
                },
                {
                    prop: 'channelName',
                    label: 'common.BELONG_TO_QUEUE',
                    tableWidth: '200',
                    showOverflowTooltip: true
                },
                {
                    prop: 'mqName',
                    label: 'common.BELONGED_MQ',
                    tableWidth: '200',
                    showOverflowTooltip: true
                },
                {
                    prop: 'iType',
                    label: 'common.ROLE',
                    align: 'center',
                    tableWidth: '100',
                    render: (createElement, params) => {
                        return createElement('label', this.transferRoleType(params.row));
                    }
                },
                {
                    prop: 'sRoutingKey',
                    label: 'common.ROUTING_KEY',
                    tableWidth: '200',
                    showOverflowTooltip: true
                },
                {
                    prop: 'sDescription',
                    label: 'common.DESCRIPTION',
                    showOverflowTooltip: true
                },
                {
                    prop: 'iStatus',
                    label: 'common.RUNSTATUS',
                    align: 'center',
                    tableWidth: '100',
                    render: (createElement, params) => {
                        if (params.row.iStatus === window.pgCommon.resourceStatus.using) {
                            return createElement('span', this.$t('common.ISUSING'));
                        }
                        return createElement('span', this.$t('common.STOPPED'));
                    }
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    align: 'center',
                    tableWidth: '120',
                    render: (createElement, params) => {
                        let a1 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['resource:edit'] },
                                on: {
                                    click: () => {
                                        this.btnEdit(params.row);
                                    }
                                }
                            },
                            this.$t('common.EDIT')
                        );
                        let a2 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['resource:control'] },
                                on: {
                                    click: () => {
                                        this.btnStart(params.row);
                                    }
                                }
                            },
                            this.$t('common.START')
                        );
                        let a3 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['resource:control'] },
                                on: {
                                    click: () => {
                                        this.btnStop(params.row);
                                    }
                                }
                            },
                            this.$t('common.UNUSED')
                        );
                        let a4 = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: ['resource:del'] },
                                on: {
                                    click: () => {
                                        this.btnDelete(params.row.sSrcId);
                                    }
                                }
                            },
                            this.$t('common.DELETE')
                        );
                        let list = [];
                        if (params.row.iStatus === window.pgCommon.resourceStatus.using) {
                            list.push(a3);
                        } else {
                            list.push(a2);
                            if (params.row.iEnableDeleteFlg === 0) {
                                list.push(a1);
                                list.push(a4);
                            }
                        }
                        return createElement('div', list);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        //页面权限设置
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.btnQuery(); // 进行页面初始化数据的加载
            }
        },
        // 角色类型转换
        transferRoleType(row) {
            switch (row.iType) {
                case 1:
                    return this.$t('common.CONSUMER');
                    // eslint-disable-next-line no-unreachable
                    break;
                default:
                    return this.$t('common.PRODUCER');
            }
        },

        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        queryDataList() {
            let param = {
                sId: this.fromResource.sSrcId,
                queueName: this.fromResource.sQueueName,
                resourceName: this.fromResource.sResourceName,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isPage: true
            };
            resourceApi.queryResourceInfo(JSON.stringify(param), response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.loading = false;
                    this.$log.error('resourceManager/queryResourceInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('resourceManager/queryResourceInfo', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content.resultlist;
                this.total = response.data.content.total;
                this.loading = false;
            });
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            this.currentPage = 1;
            this.queryDataList();
        },

        // 添加
        btnAddResource() {
            this.title = this.$t('common.ADD'); // 标题
            this.isAddData = true;
            this.dialogResourceVisible = true;
        },

        // 编辑
        btnEdit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT');
            this.isAddData = false;
            this.dialogResourceVisible = true;
        },
        // 删除接口
        btnDelete(sSrcId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.tableLoading = true;
                    let param = { sSrcId: sSrcId };
                    resourceApi.deleteResource(param, response => {
                        if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                            this.tableLoading = false;
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('resourceManager/deleteResource', response.data.statusMessage);
                            return;
                        }
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS') });
                        this.submit();
                        this.tableLoading = false;
                    });
                })
                .catch(() => {});
        },
        // 启用资源
        btnStart(row) {
            this.tableLoading = true;
            let param = {
                sSrcId: row.sSrcId,
                sName: row.sName,
                iType: row.iType,
                channelId: row.channelId,
                sRoutingKey: row.sRoutingKey,
                sDescription: row.sDescription,
                iStatus: window.pgCommon.resourceStatus.using
            };
            resourceApi.updateResourceStatu(param, response => {
                if (response.status === undefined) {
                    this.tableLoading = false;
                    return;
                }
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.tableLoading = false;
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    this.$log.error('/interfaceManager/updateResourceStatu', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.tableLoading = false;
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/interfaceManager/updateResourceStatu', response.data.statusMessage);
                    return;
                }
                this.queryDataList();
                this.tableLoading = false;
            });
        },
        // 禁用资源
        btnStop(row) {
            this.tableLoading = true;
            let param = {
                sSrcId: row.sSrcId,
                sName: row.sName,
                iType: row.iType,
                channelId: row.channelId,
                sRoutingKey: row.sRoutingKey,
                sDescription: row.sDescription,
                iStatus: window.pgCommon.resourceStatus.unUsing
            };
            resourceApi.updateResourceStatu(param, response => {
                if (response.status === undefined) {
                    this.tableLoading = false;
                    return;
                }
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.tableLoading = false;
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    this.$log.error('/interfaceManager/updateResourceStatu', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.tableLoading = false;
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/interfaceManager/updateResourceStatu', response.data.statusMessage);
                    return;
                }
                this.queryDataList();
                this.tableLoading = false;
            });
        },
        // 组件关闭需要调用的方法
        submit() {
            this.queryDataList();
        },
        // 关闭页面
        resourceDialogClose() {
            this.dialogResourceVisible = false;
        },
        // 关闭关联设置页面
        relatedSetDlgClose() {
            this.dialogRelatedSetVisible = false;
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
